jQuery(window).bind("pageshow", function(event) {
  jQuery(".preloader").hide();
});

jQuery(document).ready(function() {

  var uniqueId = (new Date()).getTime();

  const $html = $(document.documentElement);
  $('.radio-block__btn').click(function(){
      $html.css('overflow', 'hidden');
  });
  $('.close-btn').click(function(){
      $html.css('overflow', '');
  });
  $('.add-player-btn').click(function(){
    $('.switch-player').find('input[type="checkbox"]').prop('checked', true).change();
    $('.close-btn').click();
  });

  $(".radio-block__btn").on("click", function() {
    $("#popup-plan").addClass("active");
  });

  $(".close-btn").on("click", function() {
    $("#popup-plan").removeClass("active");
  });

  function checkPlan() {
    var albums = jQuery('input[name="albums-per-month"]:checked');
    var payment = jQuery('input[name="payment"]:checked');
    var discount = jQuery('input[name="discount"]:checked');
    var className = '';
    
    if ( albums.length ) {
      className = albums.val();
    }
    
    if ( payment.length ) {
      className += '_' + payment.val();
    }
    
    if ( discount.length ) {
      className += '_' + discount.data('value');
    }
    //console.log(className);
    
    var subscription = jQuery('input[name="subscription"].'+className);
    if ( subscription.length ) {
      subscription.click();
    }
    
  }

  jQuery(document).on('click','.plan-block input[type="radio"]', function(e){
    var $this = jQuery(this);
    var payment = jQuery('input[name="payment"]:checked');
    var checkbox = jQuery('.checkbox-welcome-pack');
    checkbox.find('.welcome-pack-annual').hide();
    checkbox.find('.welcome-pack-monthly').show();
    
    if ( ( payment.val() == 'annual' ) ) {
      checkbox.find('.welcome-pack-monthly').hide();
      checkbox.find('.welcome-pack-annual').show();
      jQuery('input[name="discount"]').prop( "checked", true ).change();
    }
  });
  
  jQuery(document).on('click','.plan-block input[type="radio"], .checkbox-discount input[type="checkbox"]', function(e){
    var $this = jQuery(this);
    var checkbox = jQuery('.checkbox-welcome-pack');
    var free_pack = jQuery('.welcome-pack');
    var payment = jQuery('input[name="payment"]:checked');
    var discount = jQuery('input[name="discount"]:checked');
    
    if ( ( payment.attr('name') == 'payment' ) ) {
      checkbox.show();
      if ( discount.length ) {
        free_pack.show();
      }
    } else {
      checkbox.hide();
      free_pack.hide();
      if ( discount.length ) {
        discount.prop( "checked", false );
      }
    }

    if ( !payment.length ) {
      jQuery('input[id="monthly"]').prop( "checked", true ).click();
    }
    
    checkPlan();
  });
  
  jQuery(document).on('click change','input[name="discount"]', function(e){ 
    if ($(this).is(":checked")) {
       $(".welcome-pack").show();
      $(".free-welcome-text").show();
    } else {
       $(".welcome-pack").hide();
      $(".free-welcome-text").hide();
    }
  });
  

  jQuery(document).on('change','.switch-player input[type="checkbox"]', function(e){ 
    if ($(this).is(":checked")) {
       $(".player-info").show();
    } else {
       $(".player-info").hide();
    }
  });

  jQuery(document).on('change','input[name="discount"], .checkbox-discount input[type="checkbox"], .switch-player input[type="checkbox"]', function(e){
    var subscription = jQuery('input[name="subscription"]:checked');
    jQuery('input[name="subscription"]:checked').change();
  });
  
  jQuery(document).on('change','input[name="subscription"]', function(e){
    var $this = jQuery(this);
    var button = jQuery('button[type="submit"]');
    var payment = jQuery('input[name="payment"]:checked');
    var discount = jQuery('input[name="discount"]:checked');
    var player = $('.switch-player input[type="checkbox"]:checked').data('player');
    var amount = jQuery('.amount');
    var checkbox = jQuery('.checkbox-welcome-pack');
    var free_pack = amount.find('.welcome-pack');
    var free_pack_id = $this.attr('data-free_pack');
    var price_line1 = $this.attr('data-price_line1');
    var price_line1_player = $this.attr('data-price_line1_player');
    var price_line1_player_free_pack = $this.attr('data-price_line1_player_free_pack');
    var details_info = jQuery('.details-info');
    if ( player && discount.length ) {
      price_line1 = price_line1_player_free_pack;
    } else if ( player ) {
      price_line1 = price_line1_player;
    }
    var price_line2 = $this.attr('data-price_line2');
    var price_line2_player = $this.attr('data-price_line2_player');
    var price_line2_player_free_pack = $this.attr('data-price_line2_player_free_pack');
    if ( player && discount.length ) {
      price_line2 = price_line2_player_free_pack;
    } else if ( player ) {
      price_line2 = price_line2_player;
    }
    var price_line3 = $this.attr('data-price_line3');
    var price_line3_player = $this.attr('data-price_line3_player');
    var price_line3_player_free_pack = $this.attr('data-price_line3_player_free_pack');
    if ( player && discount.length ) {
      price_line3 = price_line3_player_free_pack;
    } else if ( player ) {
      price_line3 = price_line3_player;
    }
    var info_line = $this.attr('data-info');
    var info_line_player = $this.attr('data-info_player');
    var info_line_player_free_pack = $this.attr('data-info_player_free_pack');
    if ( player && discount.length ) {
      info_line = info_line_player_free_pack;
    } else if ( player ) {
      info_line = info_line_player;
    }
    //console.log($this);
    if ( $this.length ) {
      amount.find('.price-line1').html(price_line1);
      amount.find('.price-line2').html(price_line2);
      amount.find('.price-line3').html(price_line3);
      details_info.find('.the-details__text').html(info_line);
      if ( ( payment.attr('name') == 'payment' ) ) {
         if ( discount.length ) {
           checkbox.show();
         }
      } else {
        checkbox.hide();
        if ( discount.length ) {
          discount.prop( "checked", false );
        }
      }
      if ( (typeof free_pack_id !== "undefined") && (typeof free_pack_id !== "null") && ( free_pack_id ) && ( discount.length ) ) {
        free_pack.show();
      } else {
        free_pack.hide();
      }
      details_info.show();
      amount.show();
      button.css('opacity', '1');
      button.removeAttr('disabled');
    } else {
      details_info.hide();
      amount.hide();
      checkbox.hide();
      free_pack.hide();
      amount.find('.price-line').empty();
      button.css('opacity', '0.5');
      button.attr('disabled', 'disabled');
    }
  });
  
  jQuery(document).on('click','button[type="submit"]', function(e){
    e.preventDefault();
    var subscription = jQuery('input[name="subscription"]:checked');
    if ( (typeof subscription !== "undefined") && (typeof subscription !== "null") ) {
      
      var variantId = subscription.val();
      var sell_plan = subscription.attr('data-sell_plan');
      var free_pack = subscription.attr('data-free_pack');
      var player = $('.switch-player input[type="checkbox"]:checked').data('player');
      
      if ( free_pack ) {
        var promo_data = {
          "id": free_pack,
          "quantity": 1
        };
      }

      if ( player ) {
        var player_data = {
          "id": player,
          "quantity": 1
        };
      }
      
      if ( variantId && sell_plan ) {
        
        jQuery('.preloader').show();

        var attributes = {
          "planpage": 1,
          "planpage_new": "",
          "free_pack": "",
          "free_pack_id": "",
          "free_pack_text": ""
        };
        
        var product_data = {
          "id": variantId,
          "quantity": 1,
          "selling_plan": sell_plan,
          "attributes": attributes
        };
        
        jQuery.ajax({
          type: "POST",
          url: '/cart/clear.js',
          dataType: 'json',
          success: function(){
            jQuery.ajax({
              type: "POST",
              url: "/cart/add.js",
              data: product_data,
              dataType: "json",
              success: function (response) {
                if ( player_data ) {
                  jQuery.ajax({
                    type: "POST",
                    url: "/cart/add.js",
                    data: player_data,
                    dataType: "json",
                    success: function (response) {
                      if ( promo_data ) {
                        jQuery.ajax({
                          type: "POST",
                          url: "/cart/add.js",
                          data: promo_data,
                          dataType: "json",
                          success: function (response) {
                            window.location.href = '/checkout';
                          },
                          error: function(xhr, status, error) {
                            $(".preloader").hide();
                            alert(xhr.responseJSON.description);
                          }
                        });
                      } else {
                        window.location.href = '/checkout';
                      }
                    },
                    error: function(xhr, status, error) {
                      $('.switch-player').find('input[type="checkbox"]').prop('checked', false).change();
                      $(".preloader").hide();
                      alert(xhr.responseJSON.description);
                    }
                  });
                } else {
                  if ( promo_data ) {
                    jQuery.ajax({
                      type: "POST",
                      url: "/cart/add.js",
                      data: promo_data,
                      dataType: "json",
                      success: function (response) {
                        window.location.href = '/checkout';
                      },
                      error: function(xhr, status, error) {
                        $(".preloader").hide();
                        alert(xhr.responseJSON.description);
                      }
                    });
                  } else {
                    window.location.href = '/checkout';
                  }
                }
              },
              error: function(xhr, status, error) {
                $(".preloader").hide();
                alert(xhr.responseJSON.description);
              }
            });
          }
        });
      }
      
    }
  });
  
});
